import { IPayrollPunchSet, IPunchSetDocument, ITimecardPunchSet } from "../models"
import * as utils from "./utils"

export function getTotalProductiveInHours(ps: IPunchSetDocument | IPayrollPunchSet | ITimecardPunchSet): number {
    let total = 0
    total += ps.RegHours
    total += ps.OTHours
    total += ps.OT2Hours
    return utils.roundToTwo(total)
}

export function getEffectiveTotalDurationInHours(ps: IPunchSetDocument | IPayrollPunchSet | ITimecardPunchSet): number {
    return ps.RoundingRuleId ? ps.RoundedHours : ps.Hours
}